import { useEffect, useMemo, useState } from "react";
import api from "../api";
import { useTheme } from "../components/Theme";

const NOMES_MODULOS = { leads: "Leads", negociacoes: "Negociações", orcamentos: "Orçamentos", projetos: "Central do Projeto", produtos: "Produtos", atividades: "Atividades", clientes: "Clientes", calendario: "Calendário", gestao: "Gestão", dashboard: "Dashboard", financeiro: "Financeiro", relatorios: "Relatórios", historico: "Histórico", vendas: "Painel Vendas", comissoes: "Comissões", financa: "Finança Pessoal", usuarios: "Time / Usuários", configuracoes: "Configurações" };
const NOMES_ACOES = { bloquear: "Bloqueou", desbloquear: "Desbloqueou", estender: "Estendeu o teste", ativar: "Ativou", editar: "Editou", lixeira: "Mandou para a lixeira", restaurar: "Restaurou", senha: "Trocou a senha de", entrar_como: "Entrou como", apagar_definitivo: "Apagou definitivamente", apagar_automatico: "Lixeira apagou" };
const dataBR = (d) => (d ? new Date(d).toLocaleDateString("pt-BR", { timeZone: "America/Sao_Paulo" }) : "—");
const dataHoraBR = (d) => (d ? new Date(d).toLocaleString("pt-BR", { timeZone: "America/Sao_Paulo", day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "—");
const diasAte = (d) => Math.ceil((new Date(d) - new Date()) / 86400000);
const haQuanto = (d) => { if (!d) return "nunca"; const dias = Math.floor((Date.now() - new Date(d)) / 86400000); return dias <= 0 ? "hoje" : dias === 1 ? "ontem" : `há ${dias} dias`; };

function situacao(e) {
  if (e.excluidaEm) return { k: "lixeira", t: "Na lixeira", c: "#6B7080" };
  if (e.status === "bloqueada" || e.ativo === false) return { k: "bloqueada", t: "Bloqueada", c: "#e2445c" };
  if (e.status === "trial") { const d = e.trialAte ? diasAte(e.trialAte) : 0; return d > 0 ? { k: "trial", t: `Teste · ${d} dia${d > 1 ? "s" : ""}`, c: "#d98b00" } : { k: "vencido", t: "Teste vencido", c: "#e2445c" }; }
  return { k: "ativa", t: "Ativa", c: "#00a060" };
}

export function VoltarMaster() {
  let salvo = null;
  try { salvo = JSON.parse(localStorage.getItem("crm_master_volta") || "null"); } catch (e) {}
  if (!salvo) return null;
  const voltar = () => {
    try {
      localStorage.setItem("crm_token", salvo.token);
      localStorage.setItem("crm_user", salvo.user);
      localStorage.removeItem("crm_empresa"); localStorage.removeItem("crm_funil"); localStorage.removeItem("crm_master_volta");
    } catch (e) {}
    window.location.href = "/";
  };
  return (
    <button type="button" onClick={voltar} title="Voltar para a sua conta"
      style={{ height: 32, padding: "0 12px", borderRadius: 8, border: "none", background: "#e2445c", color: "#fff", fontWeight: 700, fontSize: 12, cursor: "pointer", fontFamily: "inherit" }}>
      Modo suporte · Voltar ao Painel Master
    </button>
  );
}

export default function PainelMaster() {
  const { theme } = useTheme();
  const COR = theme.orange || "#EE6A1A";
  const cinza = theme.textMuted;
  const [dados, setDados] = useState({ empresas: [], modulos: [], diasLixeira: 30 });
  const [erro, setErro] = useState("");
  const [busca, setBusca] = useState("");
  const [filtro, setFiltro] = useState("todas");
  const [aba, setAba] = useState("empresas");
  const [logs, setLogs] = useState([]);
  const [sel, setSel] = useState(null);
  const [usuarios, setUsuarios] = useState([]);
  const [form, setForm] = useState(null);
  const [msg, setMsg] = useState(null);
  const [ocupado, setOcupado] = useState(false);
  const [senhas, setSenhas] = useState({});
  const [confirmaNome, setConfirmaNome] = useState("");
  const [dias, setDias] = useState(7);

  const carregar = () => api.get("/master/empresas").then((r) => setDados(r.data)).catch((e) => setErro(e.response?.data?.message || "Não foi possível carregar as empresas."));
  useEffect(() => { carregar(); }, []);
  useEffect(() => { if (aba === "historico") api.get("/master/logs").then((r) => setLogs(r.data.logs || [])).catch(() => {}); }, [aba]);

  const abrir = (e) => {
    setSel(e); setMsg(null); setConfirmaNome(""); setSenhas({}); setDias(7);
    setForm({ nome: e.nome, plano: e.plano || "", telefone: e.telefone || "", modulos: e.modulos && e.modulos.length ? e.modulos : dados.modulos });
    setUsuarios([]);
    api.get(`/master/empresas/${e._id}/usuarios`).then((r) => setUsuarios(r.data.usuarios || [])).catch(() => {});
  };
  const acao = async (nome, extra = {}, textoOk) => {
    setOcupado(true); setMsg(null);
    try {
      await api.put(`/master/empresas/${sel._id}`, { acao: nome, ...extra });
      const r = await api.get("/master/empresas"); setDados(r.data);
      const nova = r.data.empresas.find((x) => x._id === sel._id); if (nova) setSel(nova);
      setMsg({ t: textoOk || "Feito!" });
    } catch (e) { setMsg({ erro: true, t: e.response?.data?.message || "Não foi possível concluir." }); }
    finally { setOcupado(false); }
  };
  const trocarSenha = async (u) => {
    const s = senhas[u._id] || "";
    if (s.length < 6) return setMsg({ erro: true, t: "A senha precisa ter pelo menos 6 caracteres." });
    try { await api.post(`/master/empresas/${sel._id}/senha`, { userId: u._id, senha: s }); setSenhas((x) => ({ ...x, [u._id]: "" })); setMsg({ t: `Senha de ${u.email} alterada.` }); }
    catch (e) { setMsg({ erro: true, t: e.response?.data?.message || "Erro ao trocar a senha." }); }
  };
  const entrarComo = async () => {
    if (!window.confirm(`Entrar na conta de "${sel.nome}" para suporte? Isso fica registrado no histórico.`)) return;
    try {
      const r = await api.post(`/master/empresas/${sel._id}/entrar`);
      localStorage.setItem("crm_master_volta", JSON.stringify({ token: localStorage.getItem("crm_token"), user: localStorage.getItem("crm_user") }));
      localStorage.setItem("crm_token", r.data.token);
      localStorage.setItem("crm_user", JSON.stringify(r.data.user));
      localStorage.setItem("crm_empresa", JSON.stringify(r.data.empresa));
      localStorage.removeItem("crm_funil");
      window.location.href = "/";
    } catch (e) { setMsg({ erro: true, t: e.response?.data?.message || "Não foi possível entrar na conta." }); }
  };
  const apagar = async () => {
    if (!window.confirm("Apagar DEFINITIVAMENTE esta empresa e todos os dados dela? Não tem volta.")) return;
    try {
      await api.delete(`/master/empresas/${sel._id}`, { data: { confirmacao: confirmaNome } });
      setSel(null); carregar();
    } catch (e) { setMsg({ erro: true, t: e.response?.data?.message || "Erro ao apagar." }); }
  };

  const lista = useMemo(() => {
    const q = busca.trim().toLowerCase();
    return dados.empresas.filter((e) => {
      const s = situacao(e).k;
      const okF = filtro === "todas" ? s !== "lixeira" : filtro === "trial" ? s === "trial" || s === "vencido" : s === filtro;
      const okQ = !q || [e.nome, e.slug, e.segmento, e.telefone].some((v) => String(v || "").toLowerCase().includes(q));
      return okF && okQ;
    });
  }, [dados, busca, filtro]);
  const conta = (k) => dados.empresas.filter((e) => { const s = situacao(e).k; return k === "trial" ? s === "trial" || s === "vencido" : k === "todas" ? s !== "lixeira" : s === k; }).length;

  const card = { background: theme.bgCard || theme.bgInput, border: `1px solid ${theme.border}`, borderRadius: 15 };
  const btn = (tipo) => ({ height: 36, padding: "0 14px", borderRadius: 9, cursor: "pointer", fontFamily: "inherit", fontSize: 13, fontWeight: 700, border: tipo === "linha" ? `1px solid ${theme.border}` : "none", background: tipo === "perigo" ? "#e2445c" : tipo === "ok" ? "#00a060" : tipo === "linha" ? "transparent" : COR, color: tipo === "linha" ? theme.text : "#fff", opacity: ocupado ? 0.6 : 1 });
  const inp = { height: 36, boxSizing: "border-box", padding: "0 10px", borderRadius: 8, border: `1px solid ${theme.border}`, background: theme.bgInput, color: theme.text, fontSize: 14, fontFamily: "inherit" };
  const th = { textAlign: "left", padding: "10px 14px", fontSize: 11, fontWeight: 600, color: cinza, textTransform: "uppercase", letterSpacing: ".05em", borderBottom: `1px solid ${theme.border}`, whiteSpace: "nowrap" };
  const td = { padding: "12px 14px", fontSize: 13, color: theme.text, borderBottom: `1px solid ${theme.border}`, whiteSpace: "nowrap" };
  const secao = (t) => <div style={{ fontSize: 12, fontWeight: 700, color: cinza, textTransform: "uppercase", letterSpacing: ".05em", margin: "22px 0 10px" }}>{t}</div>;

  return (
    <div style={{ padding: 24, fontFamily: "'Inter',-apple-system,sans-serif" }}>
      <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", flexWrap: "wrap", gap: 12, marginBottom: 20 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 26, fontWeight: 800, color: theme.text }}>Painel Master</h1>
          <p style={{ margin: "4px 0 0", fontSize: 14, color: cinza }}>Todas as empresas que usam o CRM. Visível só para a administração da plataforma.</p>
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          {[["empresas", "Empresas"], ["historico", "Histórico"]].map(([k, t]) => (
            <button key={k} type="button" onClick={() => setAba(k)} style={{ ...btn(aba === k ? "" : "linha") }}>{t}</button>
          ))}
        </div>
      </div>
      {erro && <div style={{ ...card, padding: 16, color: "#e2445c", marginBottom: 16 }}>{erro}</div>}

      {aba === "empresas" && (<>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: 12, marginBottom: 16 }}>
          {[["todas", "Empresas", theme.text], ["trial", "Em teste", "#d98b00"], ["ativa", "Ativas", "#00a060"], ["bloqueada", "Bloqueadas", "#e2445c"], ["lixeira", "Na lixeira", "#6B7080"]].map(([k, t, c]) => (
            <button key={k} type="button" onClick={() => setFiltro(k)} style={{ ...card, padding: "14px 16px", textAlign: "left", cursor: "pointer", fontFamily: "inherit", borderColor: filtro === k ? COR : theme.border, boxShadow: filtro === k ? `0 0 0 3px ${COR}22` : "none" }}>
              <div style={{ fontSize: 12, color: cinza }}>{t}</div>
              <div style={{ fontSize: 26, fontWeight: 800, color: c }}>{conta(k)}</div>
            </button>
          ))}
        </div>
        <input value={busca} onChange={(e) => setBusca(e.target.value)} placeholder="Buscar por nome, segmento ou telefone…" style={{ ...inp, width: "100%", maxWidth: 420, marginBottom: 12, height: 40 }} />
        <div style={{ ...card, overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead><tr>{["Empresa", "Situação", "Segmento", "Usuários", "Leads", "Último acesso", "Cadastro", ""].map((h) => <th key={h} style={th}>{h}</th>)}</tr></thead>
            <tbody>
              {lista.map((e) => { const s = situacao(e); return (
                <tr key={e._id} onClick={() => abrir(e)} style={{ cursor: "pointer" }}>
                  <td style={td}><div style={{ fontWeight: 700 }}>{e.nome}{e.protegida && <span style={{ marginLeft: 6, fontSize: 10, color: cinza }}>🔒 interna</span>}</div><div style={{ fontSize: 11, color: cinza }}>{e.telefone || e.slug}</div></td>
                  <td style={td}><span style={{ fontSize: 12, fontWeight: 700, color: s.c, background: s.c + "18", padding: "3px 10px", borderRadius: 99 }}>{s.t}</span></td>
                  <td style={td}>{e.segmento || "—"}</td>
                  <td style={td}>{e.usuarios}</td>
                  <td style={td}>{e.leads}</td>
                  <td style={{ ...td, color: !e.ultimoAcesso || diasAte(e.ultimoAcesso) < -7 ? "#e2445c" : theme.text }}>{haQuanto(e.ultimoAcesso)}</td>
                  <td style={td}>{dataBR(e.createdAt)}</td>
                  <td style={{ ...td, color: COR, fontWeight: 700 }}>Gerenciar →</td>
                </tr>
              ); })}
              {lista.length === 0 && <tr><td colSpan={8} style={{ ...td, textAlign: "center", color: cinza, padding: 30 }}>Nenhuma empresa aqui.</td></tr>}
            </tbody>
          </table>
        </div>
      </>)}

      {aba === "historico" && (
        <div style={{ ...card, overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead><tr>{["Quando", "Quem", "Ação", "Empresa", "Detalhe"].map((h) => <th key={h} style={th}>{h}</th>)}</tr></thead>
            <tbody>
              {logs.map((l) => (
                <tr key={l._id}><td style={td}>{dataHoraBR(l.em)}</td><td style={td}>{l.por}</td><td style={td}>{NOMES_ACOES[l.acao] || l.acao}</td><td style={td}>{l.empresaNome || "—"}</td><td style={{ ...td, color: cinza }}>{l.detalhe || ""}</td></tr>
              ))}
              {logs.length === 0 && <tr><td colSpan={5} style={{ ...td, textAlign: "center", color: cinza, padding: 30 }}>Nenhuma ação registrada ainda.</td></tr>}
            </tbody>
          </table>
        </div>
      )}

      {sel && form && (
        <div onClick={() => setSel(null)} style={{ position: "fixed", inset: 0, zIndex: 3000, background: "rgba(10,12,16,.45)", display: "flex", justifyContent: "flex-end" }}>
          <div onClick={(e) => e.stopPropagation()} style={{ width: 560, maxWidth: "100%", height: "100%", overflowY: "auto", background: theme.bg, padding: 24, boxSizing: "border-box" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 12 }}>
              <div>
                <h2 style={{ margin: 0, fontSize: 22, fontWeight: 800, color: theme.text }}>{sel.nome}</h2>
                <div style={{ marginTop: 6 }}><span style={{ fontSize: 12, fontWeight: 700, color: situacao(sel).c, background: situacao(sel).c + "18", padding: "3px 10px", borderRadius: 99 }}>{situacao(sel).t}</span></div>
              </div>
              <button type="button" onClick={() => setSel(null)} style={btn("linha")}>Fechar</button>
            </div>
            {msg && <div style={{ marginTop: 14, fontSize: 14, padding: "10px 14px", borderRadius: 10, background: msg.erro ? "#ef444414" : "#00c87514", color: msg.erro ? "#e2445c" : "#00a060" }}>{msg.t}</div>}

            {secao("Dados")}
            <div style={{ ...card, padding: 16, fontSize: 13, color: theme.textSub, display: "grid", gridTemplateColumns: "140px 1fr", rowGap: 6 }}>
              <span>Segmento</span><strong style={{ color: theme.text }}>{sel.segmento || "—"}</strong>
              <span>Equipe comercial</span><strong style={{ color: theme.text }}>{sel.tamanhoEquipe || "—"}</strong>
              <span>CNPJ</span><strong style={{ color: theme.text }}>{sel.cnpj || "—"}</strong>
              <span>Cadastro</span><strong style={{ color: theme.text }}>{dataBR(sel.createdAt)}</strong>
              <span>Teste até</span><strong style={{ color: theme.text }}>{dataBR(sel.trialAte)}</strong>
              <span>Leads</span><strong style={{ color: theme.text }}>{sel.leads}</strong>
              <span>Pediu ajuda</span><strong style={{ color: theme.text }}>{sel.onboarding && sel.onboarding.querAjuda ? "Sim" : "Não"}</strong>
            </div>

            {secao("Ações")}
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8, alignItems: "center" }}>
              {!sel.excluidaEm && (sel.status === "bloqueada"
                ? <button type="button" disabled={ocupado} style={btn("ok")} onClick={() => acao("desbloquear", {}, "Empresa desbloqueada.")}>Desbloquear</button>
                : !sel.protegida && <button type="button" disabled={ocupado} style={btn("perigo")} onClick={() => window.confirm(`Bloquear "${sel.nome}"? Ninguém da empresa vai conseguir usar o CRM.`) && acao("bloquear", {}, "Empresa bloqueada.")}>Bloquear</button>)}
              {!sel.excluidaEm && sel.status !== "ativa" && <button type="button" disabled={ocupado} style={btn("ok")} onClick={() => acao("ativar", {}, "Empresa marcada como ativa.")}>Marcar como ativa</button>}
              {!sel.excluidaEm && <span style={{ display: "inline-flex", gap: 6, alignItems: "center" }}>
                <input type="number" min={1} max={365} value={dias} onChange={(e) => setDias(e.target.value)} style={{ ...inp, width: 70 }} />
                <button type="button" disabled={ocupado} style={btn("linha")} onClick={() => acao("estender", { dias }, `Teste estendido em ${dias} dias.`)}>Estender teste</button>
              </span>}
              {!sel.excluidaEm && usuarios.length > 0 && <button type="button" style={btn("")} onClick={entrarComo}>Entrar como (suporte)</button>}
            </div>

            {!sel.excluidaEm && (<>
              {secao("Editar")}
              <div style={{ ...card, padding: 16, display: "flex", flexDirection: "column", gap: 10 }}>
                <label style={{ fontSize: 13, color: theme.textSub }}>Nome<input value={form.nome} onChange={(e) => setForm({ ...form, nome: e.target.value })} style={{ ...inp, width: "100%", marginTop: 4 }} /></label>
                <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                  <label style={{ fontSize: 13, color: theme.textSub, flex: 1 }}>Plano<input value={form.plano} onChange={(e) => setForm({ ...form, plano: e.target.value })} style={{ ...inp, width: "100%", marginTop: 4 }} /></label>
                  <label style={{ fontSize: 13, color: theme.textSub, flex: 1 }}>Telefone<input value={form.telefone} onChange={(e) => setForm({ ...form, telefone: e.target.value })} style={{ ...inp, width: "100%", marginTop: 4 }} /></label>
                </div>
                <div style={{ fontSize: 13, color: theme.textSub }}>Módulos liberados</div>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))", gap: 6 }}>
                  {dados.modulos.map((m) => (
                    <label key={m} style={{ display: "flex", gap: 6, alignItems: "center", fontSize: 13, color: theme.text, cursor: "pointer" }}>
                      <input type="checkbox" checked={form.modulos.includes(m)} onChange={() => setForm({ ...form, modulos: form.modulos.includes(m) ? form.modulos.filter((x) => x !== m) : [...form.modulos, m] })} style={{ accentColor: COR }} />
                      {NOMES_MODULOS[m] || m}
                    </label>
                  ))}
                </div>
                <div><button type="button" disabled={ocupado} style={btn("")} onClick={() => acao("editar", form, "Alterações salvas.")}>Salvar alterações</button></div>
              </div>
            </>)}

            {secao("Usuários")}
            <div style={{ ...card, padding: 8 }}>
              {usuarios.length === 0 && <div style={{ padding: 12, fontSize: 13, color: cinza }}>Nenhum usuário.</div>}
              {usuarios.map((u) => (
                <div key={u._id} style={{ padding: "10px 8px", borderBottom: `1px solid ${theme.border}`, display: "flex", flexWrap: "wrap", gap: 8, alignItems: "center" }}>
                  <div style={{ flex: "1 1 200px", minWidth: 0 }}>
                    <div style={{ fontSize: 14, fontWeight: 700, color: theme.text }}>{u.nome} <span style={{ fontSize: 11, color: cinza, fontWeight: 500 }}>· {u.role}{u.ativo ? "" : " · inativo"}</span></div>
                    <div style={{ fontSize: 12, color: cinza }}>{u.email} · acesso {haQuanto(u.ultimoAcesso)}</div>
                  </div>
                  <input type="text" placeholder="Nova senha" value={senhas[u._id] || ""} onChange={(e) => setSenhas((x) => ({ ...x, [u._id]: e.target.value }))} style={{ ...inp, width: 130 }} />
                  <button type="button" style={btn("linha")} onClick={() => trocarSenha(u)}>Trocar senha</button>
                </div>
              ))}
            </div>

            {!sel.protegida && (<>
              {secao("Zona de perigo")}
              <div style={{ ...card, padding: 16, borderColor: "#e2445c55" }}>
                {!sel.excluidaEm ? (<>
                  <p style={{ margin: "0 0 10px", fontSize: 13, color: theme.textSub }}>A empresa fica bloqueada na lixeira por {dados.diasLixeira} dias e depois é apagada automaticamente. Dá para restaurar nesse período.</p>
                  <button type="button" disabled={ocupado} style={btn("perigo")} onClick={() => window.confirm(`Mandar "${sel.nome}" para a lixeira?`) && acao("lixeira", {}, "Empresa enviada para a lixeira.")}>Mandar para a lixeira</button>
                </>) : (<>
                  <p style={{ margin: "0 0 10px", fontSize: 13, color: theme.textSub }}>Na lixeira desde {dataBR(sel.excluidaEm)}. Será apagada automaticamente em {Math.max(0, dados.diasLixeira + diasAte(sel.excluidaEm))} dia(s).</p>
                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 14 }}>
                    <button type="button" disabled={ocupado} style={btn("ok")} onClick={() => acao("restaurar", {}, "Empresa restaurada.")}>Restaurar empresa</button>
                  </div>
                  <p style={{ margin: "0 0 8px", fontSize: 13, color: "#e2445c", fontWeight: 700 }}>Apagar agora, sem volta: digite o nome da empresa para confirmar.</p>
                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                    <input value={confirmaNome} onChange={(e) => setConfirmaNome(e.target.value)} placeholder={sel.nome} style={{ ...inp, flex: "1 1 200px" }} />
                    <button type="button" disabled={confirmaNome.trim() !== sel.nome.trim()} style={{ ...btn("perigo"), opacity: confirmaNome.trim() === sel.nome.trim() ? 1 : 0.4 }} onClick={apagar}>Apagar definitivamente</button>
                  </div>
                </>)}
              </div>
            </>)}
          </div>
        </div>
      )}
    </div>
  );
}
